<template>
    <div class="container-fluid">
        <div class="card p-3">
            <h3 class="p-2 m-auto fw-bold text-success text-uppercase">Calculate Your Zakat Easily</h3>
            <hr style="background: #077747"/>
            <b-form @submit="zakatCalculation" @reset.prevent="onReset">
                <div class="row p-3 m-auto">
                    <!-- Currency Field -->
                    <div class="col-md-10">
                        <b-form-group label="Currency" label-cols="4">
                            <b-form-select
                                    id="currency"
                                    placeholder="BDT ৳"
                                    v-model="formData.currencyCode"
                                    :options="nisabAmountData"
                                    text-field="text"
                                    value-field="value"
                                    @change="onCurrencyChange"
                            >
                                <option value="">Option Select</option>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <!-- Nisab Field -->
                    <div class="col-md-10 border p-2 mt-2 nisab">
                        <b-form-group
                                :label="`Nisab (Updated ${nisabUpdateDate})`"
                                label-cols="4"
                        >
                            <b-form-input
                                    class="bg-light"
                                    id="currency"
                                    placeholder="৳"
                                    v-model="formData.nisabAmount"
                                    readonly
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- Fieldset Section -->
                    <div class="col-md-10 mt-5">
                        <fieldset class="custom-fieldset p-3">
                            <legend class="custom-legend">Assets</legend>
                            <div class="mt-4">
                                <b-form-group :label="`Value Of Gold (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                              label-cols="3">
                                    <b-form-input
                                            id="name"
                                            placeholder="Enter gold value"
                                            v-model="formData.goldValue"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group label="Value Of Silver" label-cols="3">
                                    <b-form-input
                                            id="value-silver"
                                            placeholder="Enter silver value"
                                            v-model="formData.silverValue"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group
                                        :label="`Cash On Hand and Bank accounts (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                        label-cols="3">
                                    <b-form-input
                                            id="value-silver"
                                            placeholder="Enter cash value"
                                            v-model="formData.cashAndBank"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group
                                        :label="`Deposited For Some Future Purpose, e.g. Hajj (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                        label-cols="3">
                                    <b-form-input
                                            id="value-silver"
                                            placeholder="Enter deposited amount"
                                            v-model="formData.futureDeposits"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group
                                        :label="`Given Out in Loans (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                        label-cols="3">
                                    <b-form-input
                                            id="value-silver"
                                            placeholder="Enter Loans amount"
                                            v-model="formData.loanGiven"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group :label="`Investment Value (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                              label-cols="3">
                                    <b-form-input
                                            id="value-silver"
                                            placeholder="Enter Investment Value"
                                            v-model="formData.investmentValue"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div>
                                <b-form-group :label="`Rental Income (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                              label-cols="3">
                                    <b-form-input
                                            id="value-silver"
                                            placeholder="Enter Rental Income"
                                            v-model="formData.rentalIncome"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </fieldset>
                        <fieldset class="custom-fieldset p-3 mt-4">
                            <legend class="custom-legend text-danger">Liabilities</legend>
                            <div class="mt-4">
                                <b-form-group
                                        :label="`Immediate Liabilities (${selectedCurrencyInfo.currencyIcon || '৳'})`"
                                        label-cols="3">
                                    <b-form-input
                                            id="name"
                                            placeholder="Enter Immediate Liabilities"
                                            v-model="formData.immediateLiabilities"
                                            :readonly="!formData.currencyCode"
                                            :class="!formData.currencyCode ? 'bg-light text-muted' : 'bg-white text-dark'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-2 mt-3 mb-5" v-if="formData.currencyCode">
                    <button href="" type="submit" class="btn btn-outline-success">Calculate</button>
                    <button href="" type="rest" class="btn btn-outline-danger">Cancel</button>
                </div>
            </b-form>
        </div>
        <div class="row justify-content-center" v-if="nisabCalculationData.netAssets">
            <div class="col-md-12 mt-4 card custom-shadow-card  animate-fade-in">

                <!-- Net Assets Section -->
                <div class="bg-light text-success rounded p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h6 class="mb-0 fw-bold">Total Net Assets {{ selectedCurrencyInfo.currencyIcon || '৳' }}</h6>
                        <h6 class="mb-0 fw-bold">{{ nisabCalculationData.netAssets }}</h6>
                    </div>
                </div>

                <!-- Zakat Payable Section -->
                <div class="bg-success rounded text-white p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h6 class="mb-0">Zakat Payable {{ selectedCurrencyInfo.currencyIcon || '৳' }}</h6>
                        <h6 class="mb-0 fw-bold">{{ nisabCalculationData.zakatAmount }}</h6>
                    </div>
                </div>
                <div class="col-md-12 d-flex justify-content-end mt-3 mb-2">
                    <button type="submit" @click="onSubmit" class="btn btn-outline-success custom-shadow-card">Save</button>
                    <button type="reset" @click="reset" class="btn btn-outline-success custom-shadow-card mx-2">Reset
                    </button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import apiRepository from "@/services/ApiRepository";
    import {toast} from 'vue3-toastify'

    export default {
        name: "calculationZakat",
        data() {
            return {
                nisabUpdateDate: this.formatDate(new Date()),
                formData: {
                    currencyCode: "",
                    nisabAmount: "",
                    goldValue: "",
                    silverValue: "",
                    cashAndBank: "",
                    futureDeposits: "",
                    loanGiven: "",
                    investmentValue: "",
                    rentalIncome: "",
                    immediateLiabilities: "",
                },
                nisabAmountData: [],
                getNisabAll: [],
                nisabCalculationData: []
            };
        },
        computed: {
            selectedCurrencyInfo() {
                return this.getNisabAll.find(item => item.currencyCode === this.formData.currencyCode) || {};
            }
        },
        mounted() {
            this.getNisabAmount()
        },
        methods: {
            zakatCalculation() {
                const currencyCode = this.formData.currencyCode
                if (!currencyCode) {
                    toast.error('Currency Code is Missing!')
                    return;
                }
                apiRepository.zakatCalculated(this.formData).then((res) => {
                    this.nisabCalculationData = res.data;
                })
            },
            getNisabAmount(data) {
                apiRepository.getNisab(data).then((res) => {
                    this.getNisabAll = res.data
                    this.nisabAmountData = res.data.map(item => ({
                        value: item.currencyCode,
                        text: `${item.currencyCode} - ${item.currencyIcon}`
                    }));
                })
            },
            formatDate(dateString) {
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                const date = new Date(dateString);

                const day = String(date.getDate()).padStart(2, '0');
                const month = months[date.getMonth()];
                const year = date.getFullYear();

                return `${day}-${month}-${year}`;
            },
            onCurrencyChange(selectedCode) {
                const selectedItem = this.getNisabAll.find(item => item.currencyCode === selectedCode);

                if (selectedItem) {
                    this.formData.nisabAmount = selectedItem.nisabAmount;
                    this.nisabUpdateDate = this.formatDate(selectedItem.insertAt);
                } else {
                    this.formData.nisabAmount = '';
                    this.nisabUpdateDate = this.formatDate(new Date());
                }
            },
            onSubmit() {
                apiRepository.zakatCalculateSave(this.formData).then((res) => {
                    if (res) {
                        toast.success(res.data || 'Record Successfully Save.')
                        this.reset();
                        this.onReset();
                    }
                })
            },
            onReset() {
                this.formData = {
                    currencyCode: "",
                    nisabAmount: "",
                    goldValue: "",
                    silverValue: "",
                    cashAndBank: "",
                    futureDeposits: "",
                    loanGiven: "",
                    investmentValue: "",
                    rentalIncome: "",
                    immediateLiabilities: "",
                }
            },
            reset() {
                this.nisabCalculationData = {
                    netAssets: '',
                    zakatAmount: '',
                }
            }
        },
    };
</script>

<style scoped>
    /* Nisab Styling */
    .nisab {
        background: #f3f4f6;
        border: 1px solid #077747;
        border-radius: 10px;
    }

    /* Fieldset Styling */
    .custom-fieldset {
        border: 1px solid #077747;
        border-radius: 10px;
        padding: 20px;
        position: relative;
    }

    .custom-legend {
        font-weight: bold;
        font-size: 1rem;
        color: #077747;
        padding: 0 10px;
        background: #f8f9fa;
        border: 1px solid #077747;
        border-radius: 5px;
        text-transform: uppercase;
        position: absolute;
        top: -10px;
        left: 20px;
    }

    /*card design from ai*/
    .custom-shadow-card {
        border-radius: 1rem;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.7);
        transition: all 0.3s ease;
    }

    .custom-shadow-card:hover {
        transform: translateY(-6px);
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.8);
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .animate-fade-in {
        animation: fadeInUp 0.6s ease-out;
    }
</style>
